/**
 * The renderer owns the contents of #screen and nothing else.
 *
 * It must never create or destroy the <video> elements — those live in
 * index.html for exactly that reason. See docs/development-plan.md §3.2.
 */

export interface FoundationView {
  readonly title: string;
  readonly status: string;
  readonly lines: readonly string[];
}

export function render(root: HTMLElement, view: FoundationView): void {
  root.replaceChildren(
    el('h1', { class: 'title', 'data-testid': 'title' }, view.title),
    el('p', { class: 'subtitle', 'data-testid': 'status' }, view.status),
    el(
      'ul',
      { class: 'lines', 'data-testid': 'lines' },
      ...view.lines.map((line) => el('li', {}, line)),
    ),
  );
}

function el(
  tag: string,
  attrs: Record<string, string>,
  ...children: readonly (string | Node)[]
): HTMLElement {
  const node = document.createElement(tag);
  for (const [name, value] of Object.entries(attrs)) {
    node.setAttribute(name, value);
  }
  node.append(...children);
  return node;
}
